import { render, staticRenderFns } from "./CommissionWithdarw.vue?vue&type=template&id=82a61740&"
import script from "./CommissionWithdarw.vue?vue&type=script&lang=js&"
export * from "./CommissionWithdarw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports